import { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Box, FormHelperText } from "@mui/material";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { CorporateSearch, RetireeSearch } from "./components/components";
import { fakeTableList, schema } from "./parts";
import _ from "lodash";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
/**
 * SCRW110005 機構職員代行入力
 * @return SCRW110005
 */
const SCRW110005 = () => {
  const navigate = useNavigate();

  const { state } = useContext(GlobalContext);
  const { setState: setBusinessState } = useContext(BusinessContext);

  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [searchType, setSearchType] = useState("");
  const [selectedInfo, setSelectedInfo] = useState<any>({});
  const [selectedCorporate, setSelectedCorporate] = useState<any>("");
  const [selectedRetiree, setSelectedRetiree] = useState<any>("");
  const [businessType, setBusinessType] = useState<any>("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    let noOwnerReason = resArr.find(
      (item) => item.keyword === "noOwnerReason"
    )!;
    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;
    let retireeName = resArr.find((item) => item.keyword === "retireeName")!;

    noOwnerReason.onGetValue = (value: any) => {
      setSelectedInfo({});
      setSelectedCorporate("");
      setSelectedRetiree("");
      setSearchType(value ? value.search : "");
      setBusinessType(value ? value.jobType : "");
      setErrorMsg("");
    };

    const values = Object.values(selectedInfo).length;

    contractorName.node = (
      <Box>
        <CorporateSearch
          onSave={setSelectedInfo}
          selectedCorporate={selectedCorporate}
          setSelectedCorporate={setSelectedCorporate}
          businessType={businessType}
        />
        {errorMsg && (!values || values !== 2) && (
          <FormHelperText error>{errorMsg}</FormHelperText>
        )}
      </Box>
    );
    retireeName.node = (
      <Box>
        <RetireeSearch
          onSave={setSelectedInfo}
          businessType={businessType}
          selectedRetiree={selectedRetiree}
          setSelectedRetiree={setSelectedRetiree}
        />
        {errorMsg && (!values || values !== 5) && (
          <FormHelperText error>{errorMsg}</FormHelperText>
        )}
      </Box>
    );

    setStatecorpInfoList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, businessType, errorMsg, selectedInfo]);

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;
    let retireeName = resArr.find((item) => item.keyword === "retireeName")!;

    contractorName.showLine = searchType === "CONTRACTOR";
    retireeName.showLine = searchType === "RETIREE";

    setStatecorpInfoList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchType]);

  const handleSubmit = (data: any) => {
    const values = Object.values(selectedInfo).length;
    if (searchType === "CONTRACTOR" && (!values || values !== 2)) {
      setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
      return;
    }
    if (searchType === "RETIREE" && (!values || values !== 5)) {
      setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
      return;
    }
    setBusinessState({
      common: {
        businessType: data.noOwnerReason.jobType,
        contractorNo: selectedInfo.contractorNo,
        contractorName: selectedInfo.contractorName,
      },
    });

    navigate(data.noOwnerReason.path, {
      state: {
        facilityNo: selectedInfo.facilityNo,
        staffNo: selectedInfo.staffNo,
        staffName: selectedInfo.staffName,
      },
    });
  };

  return (
    <Box data-testid="SCRW110005PageForTest">
      <TkFakeTable
        list={statecorpInfoList}
        ruleSchema={schema}
        buttonGroup={<TkBackButton />}
        submitButtonText="次へ"
        onCheckAndSubmit={handleSubmit}
      />
    </Box>
  );
};

export default SCRW110005;
